import React, { useState } from 'react';
import NewsList from 'components/Elements/NewsList/index';
import Filter from 'components/BlogSecFilter';

import NEWS_DATA from '@/mocks/storyNews';

const News = ({ filters }) => {
  const [activeItem, setActiveIndex] = useState('filter_1');
  const [openSearch, setOpenSearch] = useState(false);

  const handleActiveItem = (e) => {
    setActiveIndex({ activeItem: e.target.id });
  };

  const handleChange = () => {
    setOpenSearch(!openSearch);
  };

  return (
    <div>
      <div>
        <Filter
          filters={filters}
          onActive={handleActiveItem}
          isActiveItem={activeItem}
          onChange={handleChange}
          isOpen={openSearch}
        />
        <NewsList news={NEWS_DATA} />
      </div>
    </div>
  );
};

export default News;
